import { createContext, useContext, useState } from "react";

const NavigationContext = createContext();

const NavigationProvider = ({ children }) => {
  const [isMobileNavigation, setIsMobileNavigation] = useState(false);

  return (
    <NavigationContext.Provider
      value={{ isMobileNavigation, setIsMobileNavigation }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export default NavigationProvider;

export function useNavigationContext() {
  return useContext(NavigationContext);
}
